import styled, { css } from 'styled-components';
import Button from '#/shared/components/Buttons';
import { ClearInput, ClearTextArea } from '#/shared/components/Styled';
import { MOBILE_MAX_BREAK } from '#/shared/constants';

const baseFieldStyle = css`
  color: ${props => props.theme.inverseFontColor1};
  font-size: 1.8em;
  font-weight: 300;
  margin: 8px 0;
`;

// The wrapper ensures that we back this with the appropriate color
export const FeedbackForm = styled.form`
  background-color: ${props => props.theme.inverseBackgroundColor1};
  color: ${props => props.theme.inverseFontColor1};
  display: flex;
  flex-flow: column;
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
`;

export const FeedbackFormFieldLabel = styled.label`
  font-size: 1em;
  display: flex;
  align-items: center;
  padding-top: 24px;
  color: ${props => props.theme.inverseFontColor1};

  @media (max-width: ${MOBILE_MAX_BREAK}) {
    font-size: 1.2em;
  }
`;

export const FeedbackFormInput = styled(ClearInput).attrs(props => ({
  'aria-label': props.placeholder,
  autocomplete: 'false',
}))`
  ${baseFieldStyle};
  flex: 1 1 auto;
  max-height: 40px;
  border-bottom: 1px solid ${props => props.theme.inputBorderColorReverse};
  padding: 0;

  &::placeholder {
    color: ${props => props.theme.inverseFontColor2};
  }

  &:focus,
  &:active {
    border-bottom: 1px solid
      ${props => props.theme.inputBorderColorFocusReverse};
  }
`;

export const FeedbackFormTextArea = styled(ClearTextArea).attrs(props => ({
  'aria-label': props.placeholder,
}))`
  ${baseFieldStyle};
  padding: 0;
  background-color: ${props => props.theme.inputBgColorReverse};
  resize: vertical;
  flex: 0 1 auto;
  border-bottom: 1px solid ${props => props.theme.inputBorderColorReverse};
  &::placeholder {
    color: ${props => props.theme.inverseFontColor2};
  }

  &:focus,
  &:active {
    border-bottom: 1px solid
      ${props => props.theme.inputBorderColorFocusReverse};
    background-color: transparent;
  }
`;

export const FeedbackFormError = styled.div`
  color: ${props => props.theme.warnColor};
  margin: 8px 0;
  flex: 0 1 auto;
`;

export const SubmitFeedbackButton = styled(Button).attrs({
  variant: 'primary',
})`
  align-self: center;
  flex-grow: 0;
  margin-top: 40px;
  width: 50%;
  max-width: 250px;
`;

export const FileInputContainer = styled.div`
  display: flex;
  align-items: center;

  & > * {
    flex-grow: 0;
  }
`;

export const FileInputButton = styled(Button).attrs({
  variant: 'outline',
})`
  margin: 8px 10px 8px 0;
  max-width: 150px;
`;

export const FileInputText = styled.span`
  ${baseFieldStyle};
  color: ${({ fileSelected, theme }) =>
    fileSelected ? 'inherit' : theme.inverseFontColor2};
  font-size: 1em;
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HiddenInput = styled.input`
  display: none;
`;
